export default __webpack_public_path__ + "static/media/bti-icon.b539062c.svg";